import { useMutation, useQueryClient, MutationKey } from "react-query";
import Axios from "axios";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { RemoteApiError } from "../useRemote/types";

/**
 * Cancels a fleet booking (DELETE /fleet/bookings/:id).
 * Notifications are handled server-side.
 */
export function useRemoteCancelFleetBooking() {
  const { t } = useTranslation();
  const snackbar = useSnackbar();
  const queryClient = useQueryClient();

  return useMutation<void, RemoteApiError, number>(
    ["fleet", "cancel-booking"] as MutationKey,
    async (bookingId: number) => {
      await Axios.delete(`/fleet/bookings/${bookingId}`);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["fleet", "vehicles"]);
        snackbar.enqueueSnackbar(t("Booking cancelled"), { variant: "success" });
      }
    }
  );
}
